import { render, staticRenderFns } from "./nav-bar.vue?vue&type=template&id=3886dc4a&scoped=true&"
import script from "./nav-bar.vue?vue&type=script&lang=js&"
export * from "./nav-bar.vue?vue&type=script&lang=js&"
import style0 from "./nav-bar.vue?vue&type=style&index=0&id=3886dc4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3886dc4a",
  null
  
)

export default component.exports